<template>
    <div>
        <div class="modal fade" id="listaPacientesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h6 class="modal-title mb-0" id="exampleModalLabel">
                            Horários: {{ ref ? $util.getFormatDate(ref) : '' }}
                        </h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-header" v-if="medicos && medicos.length > 0">
                        <div class="w-100">
                            <div class="mb-0" v-if="medicos && medicos.length > 0">
                                <az-input   
                                    v-if="false"
                                    type="button-group"
                                    :optionsList="lista_medicos"
                                    v-model="medico_selecionado"
                                    @input="refresh()" />

                                <div class="form-row">
                                    
                                    <div class="col col-12" :class=" ( datas && datas.length ) ? 'col-md-4' : 'col-md-6'">
                                        <az-input
                                            sizing="sm"
                                            icon="fa fa-search"
                                            v-model="search">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <button type="button" class="btn btn-sm" :class="todos_os_medicos ? 'btn-primary' : 'btn-outline-primary'" @click="toggle_medico()">
                                                        Todos
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>

                                    <div class="col col-12 col-md-2" v-if="datas && datas.length">
                                        <az-input
                                            icon="fa fa-calendar-check-o fa-fw"
                                            sizing="sm"
                                            type="select"
                                            :optionsList="datas.map(dt => { 
                                                return { 
                                                    id: dt,
                                                    search: $util.getFormatDate(dt)
                                                };
                                            })"
                                            optionsData="id"
                                            v-model="ref" 
                                            @input="recarregar_data()" />
                                    </div>

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Exibir Horários Livres"
                                            v-model="exibir_livre" />
                                    </div>

                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            type="button-group"
                                            :optionsList="[
                                                { id: 'M', search: 'Manhã (7-13)' },
                                                { id: 'T', search: 'Tarde (13-19)' },
                                                { id: 'G', search: 'Geral' },
                                            ]"
                                            v-model="turno" />
                                    </div>

                                </div>

                                <div v-if="!todos_os_medicos">
                                    <button type="button" class="btn btn-sm mr-1 mb-1" 
                                        :class="med.selecionado ? 'btn-secondary' : 'btn-outline-secondary'"
                                        v-for="(med, imx) in lista_medicos" :key="imx" @click="toggle_medico(med)">
                                        {{ med.search }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">

                        <div class="form-row" v-if="show_items">
                            <div class="col col-12 col-md-3" v-if="exibir_procedimentos">
                                <slot name="procedimentos"></slot>
                            </div>

                            <div class="col col-12" :class="exibir_procedimentos ? 'col-md-9' : ''">

                                <div class="card overflow-auto" style="padding: 0px; height: 64vh;">

                                    <az-empty-state v-if="!exibicao || !Object.keys(exibicao).length" />

                                    <tabela-agendas 
                                        @bloquearhorario="bloquear_horario"
                                        :pode_bloquear_horario="pode_bloquear_horario"
                                        :medico_unidades="medico_unidades"
                                        :agendas="exibicao" 
                                        :marcacoes="marcacoes"
                                        :marcacoes_recursos="marcacoes_recursos"
                                        :cores="cores"
                                        :cc="cc"
                                        :infusao="infusao"
                                        v-else-if="centro_cirurgico 
                                            || lista_medicos_selecionados.length > 1
                                            || coleta_dom
                                            || ( marcacoes_recursos && Object.keys(marcacoes_recursos).length )" />

                                    <template v-else>

                                        <div v-for="(quebra, iq) in exibicao" :key="iq">

                                            <div class="mb-1 d-flex" v-if="iq != ' Lista '"> 
                                                <h5 class="mb-0">
                                                    {{ iq }}
                                                    <span class="badge badge-secondary">{{ quebra.length }}</span>
                                                </h5>
                                            </div>

                                            <div class="card mb-2" v-for="(hor, index) in quebra" :key="index">

                                                <div class="card-body p-1">

                                                    <div class="row">

                                                        <!-- Horário -->
                                                        <div class="col col-12 col-md-2 d-flex flex-column justify-content-center">
                                                            <celula-horarios-marcacao :hor="hor" @selecionar="selecionar" />
                                                        </div>

                                                        <!-- Identificação do Paciente -->
                                                        <div class="col col-12 col-md-4" v-if="hor.marcacao">
                                                            <celula-dados-paciente :hor="hor" />
                                                        </div>

                                                        <div class="col col-12 col-md-4" v-else-if="hor.status == 'bloqueado'">
                                                            <span class="badge badge-danger">
                                                                Bloqueado
                                                            </span>
                                                        </div>

                                                        <!-- Dados do Procedimento -->
                                                        <div class="col col-12 col-md-6" v-if="hor.marcacao">
                                                            <celula-dados-procedimento :hor="hor" />
                                                        </div>

                                                        <!-- Possíveis Procedimentos -->
                                                        <div class="col col-12 col-md-10" v-else-if="proc_marcado(hor)">
                                                            <span class="badge" :class="'badge-' + cores[proc_marcado(hor).index]">
                                                                {{ proc_marcado(hor).procedimento.search }}
                                                            </span>
                                                        </div>

                                                        <!-- Possíveis Procedimentos -->
                                                        <div class="col col-12 col-md-10" v-else-if="!hor.marcacao && hor.agenda_procedimentos && hor.agenda_procedimentos.length <= 5">
                                                            <span v-for="(proc, iex) in hor.agenda_procedimentos" :key="iex">
                                                                <span class="badge mr-1" :class="proc.bloqueado ? 'badge-danger' : 'badge-primary'">
                                                                    {{ proc.st_procedimento }}
                                                                    <i class="fas fa-registered text-warning" v-if="proc.tipo_consulta == 'R'"></i>
                                                                    <i class="fas fa-copyright text-dark" v-if="proc.tipo_consulta == 'C'"></i>
                                                                </span>
                                                            </span>
                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </template>

                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer" v-if="false">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import CelulaHorariosMarcacao from '../../shared/table/CelulaHorariosMarcacao.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import CelulaDadosProcedimento from '../../shared/table/CelulaDadosProcedimento.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import TabelaAgendas from './TabelaAgendas.vue';

export default {
    data () { 
        return { 
            ref: null, 
            lista: null, 
            medico: null, 
            medicos: null,
            medico_selecionado: null, 
            exibir_livre: true, 
            search: "",
            show_items: true, 
            turno: 'G', 
            marcacoes_recursos: null, 
            coleta_dom: false, 
            medico_unidades: null, 
            pode_bloquear_horario: false, 
        }
    },

    components: { 
        CelulaHorariosMarcacao,
        CelulaDadosPaciente,
        CelulaDadosProcedimento,
        AzEmptyState, 
        AzInput, 
        TabelaAgendas, 
    },

    props: ['listaproc', 'marcacoes', 'cores', 'procedimentos', 'unico', 'datas', 'id_paciente', 'cc', 'infusao', 'block_filtro_regiao'],
    
    computed: { 
        exibir_procedimentos: function () { 
            return this.listaproc && this.marcacoes && this.marcacoes.length > 1; 
        },

        exibicao: function () { 

            if ( !this.lista )
                return null;

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            let items = this.lista.filter(item => this.exibir_livre || item.marcacao || this.proc_marcado(item))
                .filter(item => item.status != 'passado')
                .filter(item => this.turno == 'G' 
                    || ( this.turno == 'M' && item.hora >= '07:00' && item.hora < '13:00' )
                    || ( this.turno == 'T' && item.hora >= '13:00' && item.hora < '19:00' ) 
                )
                .filter(item => !this.search || reg.test(JSON.stringify(item))); 

            if ( this.centro_cirurgico || this.lista_medicos_selecionados.length > 1 || this.coleta_dom || ( this.marcacoes_recursos && Object.keys(this.marcacoes_recursos).length ) ) { 
                return ( !items || !items.length ) ? null : items;    
            } else if ( !items || !items.length ) { 
                return null;
            }

            items = _.groupBy(items, item => { 
                if ( this.medico && this.medico.search ) { 
                    return this.medico.search;
                } else if ( item.medico ) { 
                    return item.medico.st_nome_exibicao;
                } else if ( item.marcacao ) { 
                    return item.marcacao.medico.search;
                }
            });

            let ordered = {};   
            _(items).keys().sort().each(function (key) {
                ordered[key] = items[key];
            });

            return ordered;

        },

        lista_medicos: function () { 
            if ( !this.medicos )
                return [];

            return this.medicos.map(item => { 
                item.id = item.id_pessoa;
                item.search = item.st_nome_exibicao;
                return item;
            });
        },

        centro_cirurgico: function () { 
            return this.lista_medicos_selecionados.length 
                && this.lista_medicos_selecionados.find(medico => ( medico.cc || medico.inf ) )
                && !this.lista_medicos_selecionados.find(medico => !medico.cc && !medico.inf);
        },

        lista_medicos_selecionados: function () { 
            if ( !this.medicos )
                return [];

            return this.medicos.filter(item => item.selecionado);
        },

        todos_os_medicos: function () { 
            return this.medicos.find(item => !item.selecionado) ? false : true;
        }

    },

    methods: { 
        bloquear_horario(hor) { 

            /*
            if ( this.viewonly ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Bloquear Horário",
                    detail: "A edição não está disponível.",
                    life: 5000
                });
                return;
            }
            */

            let bloq_filtros = [];

            if ( hor.coleta_dom && hor.id_local ) { 
                bloq_filtros.push({
                    model_type: 'App\\azure\\local',
                    model_id: hor.id_local,
                    fl_regra: true, 
                    excluido: false, 
                    model: { 
                        id_local: hor.id_local, 
                    }
                });
            }

            this.$util.atualizar(this, { 
                service: 'bloqueios',
                func: 'horario', 
                dados: { 
                    id_medico: hor.id_medico,
                    id_agenda: hor.id_agenda,
                    dt_inicio: hor.data + ' ' + hor.hora,
                    filtros: bloq_filtros
                },
                continue_loading: true, 
                callback: () => { 
                  this.recarregar_data();
                }
            });
        },

        recarregar_data () { 
            if ( !this.lista ) { 
                return; 
            }

            this.$parent.listaPacientes(this.ref);

            // this.abrir(this.ref, null, this.medicos, true);
        },
        
        force_refresh () { 
            this.show_items = false;

            this.$nextTick(() => { 
                this.show_items = true;
            });
        },

        proc_marcado (agenda) { 
            if ( !this.marcacoes || !agenda )
                return;

            return this.marcacoes.find(item => item.id_agenda == agenda.id_agenda && item.hora == agenda.hora);
        },
        
        toggle_medico(med = null) { 
            if ( med ) { 
                med.selecionado = !med.selecionado;
            } else { 
                let selec = this.medicos.find(item => item.selecionado) ? false : true;

                this.medicos.forEach(item => { 
                    item.selecionado = selec;
                });
            }

            this.refresh();

            this.abrir(this.ref, null, this.medicos, true);
        },
        
        selecionar (dados) { 
            if ( dados && dados.status == 'bloqueado' ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Horário bloqueado.',
                    life: 5000
                });     
                return;
            }
            this.$emit('selecionar', dados);
        },

        refresh() { 
            if ( !this.medico_selecionado )
                return;

            this.abrir(this.ref, null, this.medicos, true);
        },

        abrir (ref, dados = null, medicos = null, refresh = false, unico = false) { 

            if ( !refresh ) {
                this.coleta_dom = false;
                this.search = "";
                this.medico_selecionado = null;
                
                this.medicos = _.map(
                    _.cloneDeep(medicos),
                    medico => { 
                        medico.selecionado = true;
                        return medico;
                    }
                );
            }

            this.lista = null;
            this.marcacoes_recursos = null;
            this.medico_unidades = null; 

            if ( !ref && this.ref ) { 
                ref = this.ref;
            }
            
            $('#listaPacientesModal').modal('show');

            this.ref = ref;
            this.medico = null; 

            if ( this.medico_selecionado ) { 
                this.medico = { id_pessoa: this.medico_selecionado };
            } else if ( this.lista_medicos_selecionados.length == 1 ) { 
                this.medico = { id_pessoa: this.lista_medicos_selecionados[0].id_pessoa };
            } else if ( dados && dados.length == 1 && dados[0].medico ) { 
                this.medico = dados[0].medico;
            } 

            if ( !this.medicos.filter(item => item.selecionado).length ) { 
                this.lista = [];
                return;
            }

            //

            let id_procedimento;
            let id_plano; 
            let recursos;
            let id_unidade_operacao; 
            let id_regiao_cd; 

            if ( this.listaproc 
                && this.procedimentos 
                && ( unico || this.procedimentos.filter(item => item.selected).length == 1 ) ) { 

                const proc = this.procedimentos.find(item => item.selected);

                if ( proc && proc.procedimento ) { 

                    if ( proc.regiao_cd && proc.unidade_operacao ) { 
                        id_regiao_cd = proc.regiao_cd.id_regiao_cd;
                        id_unidade_operacao = proc.unidade_operacao.id_unidade_operacao;
                        this.coleta_dom = true; 
                    }

                    id_procedimento = proc.procedimento.id_procedimento;

                    if ( proc.plano ) { 
                        id_plano = proc.plano.id_plano; 
                    }

                    recursos = proc.procedimento_equipamentos

                }
            } else { 

                if ( this.listaproc 
                    && this.procedimentos 
                    && this.procedimentos.filter(item => item.selected).length > 0 ) { 

                    recursos = _.uniqBy(
                        this.procedimentos.filter(item => item.selected && item.procedimento_equipamentos && item.procedimento_equipamentos.length)
                            .flatMap(item => item.procedimento_equipamentos),
                        'id_equipamento'
                    );

                }

            }

            //

            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: "agendas.index",
                        id: "lista_marcacao",
                        parms: {
                            data: ref,
                            medico: this.medico ? this.medico.id_pessoa : null,
                            group: "none",
                            livres: true, // this.medico ? true : false, 
                            medicos: this.medicos.filter(item => item.selecionado).map(item => item.id_pessoa),
                            confirmacao: id_procedimento ? false : true, // this.medico ? true : false, 
                            detalhe: this.listaproc ? true : false, 
                            procedimento: id_procedimento,
                            plano: id_plano, 
                            id_paciente: this.id_paciente, 
                            cc: this.cc, 
                            infusao: this.infusao, 
                            recursos: recursos, 
                            unidade_operacao: id_unidade_operacao, 
                            id_regiao_cd: id_regiao_cd, 
                            block_filtro_regiao: this.block_filtro_regiao, 
                        }
                    },
                    { 
                        name: "medico_unidades.index",
                        id: "medico_unidades",
                        parms: {
                            lista_medicos: this.medicos.filter(item => item.selecionado).map(item => item.id_pessoa),
                        }
                    },
                    {
                        name: 'configuracoes.index',
                        id: 'configmotivo',
                        parms: {
                            where: {
                                st_slug: 'motivo-bloqueio-horario',
                                fl_ativo: '1',
                            }
                        } 
                    },
                ]
            };

            this.axios.post("/aql?a=listapaciente", query)
                .then(res => {
                    this.lista = res.data.lista_marcacao.data.agendas.filter (item => { 
                        return this.medicos.find(md => { 
                            return md.id_pessoa == _.get(item, 'medico.id_pessoa') || md.id_pessoa == _.get(item, 'marcacao.id_medico');
                        });
                    });

                    if ( res.data.lista_marcacao.data.agenda_recursos ) { 
                        this.marcacoes_recursos = res.data.lista_marcacao.data.agenda_recursos;
                    }

                    if ( res.data.medico_unidades.data ) { 
                        this.medico_unidades = _.mapKeys(res.data.medico_unidades.data, item => item.id_medico);
                    }

                    if ( res.data.configmotivo && res.data.configmotivo.status == 200 ) { 
                        this.pode_bloquear_horario = ( _.get(res.data.configmotivo.data, '0.st_valor') > 0 );
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });

        },

        verMarcar (horario) { 
            this.$emit('selecionar', horario);
        }
    }
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

/* Cores Extra */

.text-vermelho { 
  color: #900;  
}

.badge-vermelho { 
  background-color: #900;  
  color: white;
}

.btn-vermelho { 
  background-color: #900;  
  color: white;
}

.btn-outline-vermelho { 
  border-color: #900;
  color: #900;
}

.list-group-item-vermelho { 
  background-color: #90000050;
}

/* Rosa */

.text-rosa { 
  color: #e83e8c;  
}

.badge-rosa { 
  background-color: #e83e8c;  
  color: white;
}

.btn-rosa { 
  background-color: #e83e8c;  
  color: white;
}

.btn-outline-rosa { 
  border-color: #e83e8c;
  color: #e83e8c;
}

.list-group-item-rosa { 
  background-color: #e83e8c50;
}

/* Teal */

.text-teal { 
  color: #20c997;  
}

.badge-teal { 
  background-color: #20c997;  
  color: white;
}

.btn-teal { 
  background-color: #20c997;  
  color: white;
}

.btn-outline-teal { 
  border-color: #20c997;
  color: #20c997;
}

.list-group-item-teal { 
  background-color: #20c99750;
}

/* Purple */

.text-purple { 
  color: #6f42c1;  
}

.badge-purple { 
  background-color: #6f42c1;  
  color: white;
}

.btn-purple { 
  background-color: #6f42c1;  
  color: white;
}

.btn-outline-purple { 
  border-color: #6f42c1;
  color: #6f42c1;
}

.list-group-item-purple { 
  background-color: #6f42c150;
}

/* Orange */

.text-orange { 
  color: #fd7e14;  
}

.badge-orange { 
  background-color: #fd7e14;  
  color: white;
}

.btn-orange { 
  background-color: #fd7e14;  
  color: white;
}

.btn-outline-orange { 
  border-color: #fd7e14;
  color: #fd7e14;
}

.list-group-item-orange { 
  background-color: #fd7e1450;
}

/* Orange */

.text-verde-escuro { 
  color: #405d27;  
}

.badge-verde-escuro { 
  background-color: #405d27;  
  color: white;
}

.btn-verde-escuro { 
  background-color: #405d27;  
  color: white;
}

.btn-outline-verde-escuro { 
  border-color: #405d27;
  color: #405d27;
}

.list-group-item-verde-escuro { 
  background-color: #405d2750;
}
</style>